module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-precomposed-f6993fb756695d13d7e1b659248bfc2e.png";